var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Form, Error, NoResults, Alert } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { postAttendeeTypes, getQuestions, getAttendee, getGroupInEvent } from "../../../../../data/api";
import Constants from "../../../../../data/constants";
import { getCartId, getLocal, LOCAL_STORAGE_KEYS, removeLocal, setLocal, } from "../../../../../data/localStorageHelpers";
import { setCartData, setQuestionsData, updateCartStatus } from "../../../../../store/Cart/actions";
import FormikContextListener from "../../../../Helpers/FormikContextListener";
import { setAutoRegMode, setFormIsSubmitting, setInlineError } from "../../../../../store/AppState/actions";
import { GroupsMode } from "../../Register";
import AccessCodeInput from "./AccessCodeInput";
import { AppFormContext } from "../../../../../App";
import { union, pick } from "lodash";
import * as qs from "query-string";
import { handleErrors } from "../../../../../data/helpers";
import WidgetFieldset from "../../../../Helpers/WidgetFieldset";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import useGroupData from "../../../../../hooks/useGroupData";
import AttendeeTypeRow from "./AttendeeTypeRow";
import useWidgetAnalytics from "../../../../../hooks/useWidgetAnalytics";
import GroupMiddlewareListener from "../../../../Helpers/GroupMiddlewareListener";
import FormikValuesListener from "../../../../Helpers/FormikValuesListener";
import GroupedMatrix from "./GroupedMatrix";
var useTypedSelector = useSelector;
var AttendeeTypes = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var eventData = _a.eventData, path = _a.path, activePaths = _a.activePaths, groupsMode = _a.groupsMode, setGroupsMode = _a.setGroupsMode, section = _a.section, typeData = _a.attendeeTypeData, _q = _a.isSingleAttendeePicker, isSingleLocal = _q === void 0 ? false : _q, currentAttendeeTypeId = _a.currentAttendeeTypeId, preSelectedAttendeeTypeId = _a.preSelectedAttendeeTypeId, handleSubmit = _a.handleSubmit, _r = _a.showGroupTypes, showGroupTypes = _r === void 0 ? false : _r, _s = _a.readonly, readonly = _s === void 0 ? false : _s, _t = _a.isGroupButtonsMatrix, isGroupButtonsMatrix = _t === void 0 ? false : _t, typeCode = _a.typeCode, setSourceAttendee = _a.setSourceAttendee, currentAttendeeTypePrice = _a.currentAttendeeTypePrice, isDisabled = _a.isDisabled, attendeeTypesFormData = _a.attendeeTypesFormData, setAttendeeTypesFormData = _a.setAttendeeTypesFormData, transferData = _a.transferData, tightenUp = _a.tightenUp, _u = _a.isAddonMatrix, isAddonMatrix = _u === void 0 ? false : _u, hasUnpaidInvoice = _a.hasUnpaidInvoice;
    var _v = __read(useState(false), 2), hasGroups = _v[0], setHasGroups = _v[1];
    var _w = __read(useState([]), 2), customPriceErrors = _w[0], setCustomPriceErrors = _w[1];
    var _x = __read(useState(preSelectedAttendeeTypeId), 2), selectedAttendeeType = _x[0], setSelectedAttendeeType = _x[1];
    var _y = __read(useState(false), 2), setShowAttendeeCountError = _y[1];
    var _z = __read(useState(0), 2), render = _z[0], setRender = _z[1];
    var _0 = __read(useState(null), 2), sourceAttendeeId = _0[0], setSourceAttendeeId = _0[1];
    var _1 = __read(useState(false), 2), acceptedTerms = _1[0], setAcceptedTerms = _1[1];
    var _2 = __read(useState(false), 2), showRemainingAlert = _2[0], setShowRemainingAlert = _2[1];
    var _3 = __read(useState(), 2), cartAddInput = _3[0], setCartAddInput = _3[1];
    var _4 = useTypedSelector(function (store) { return store.cart; }), cartStatus = _4.cartStatus, cart = _4.cart;
    var _5 = useTypedSelector(function (store) { return store.app; }), isAutoRegMode = _5.isAutoRegMode, globalLoaders = _5.globalLoaders;
    var constants = useTypedSelector(function (store) { return store.utilities; }).constants;
    var eventIsLoading = globalLoaders.eventIsLoading;
    //const { attendeeTypeData: reduxAttendeeTypeData } = useTypedSelector((store) => store.attendees);
    var formikContext = useContext(AppFormContext).formikContext;
    // const attendeeTypeData = section?.id
    // 	? reduxAttendeeTypeData?.filter((att) => att.sections.find((sec) => sec.sectionId === section?.id))
    // 	: reduxAttendeeTypeData;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var domHistory = useHistory();
    var location = useLocation();
    var queryParams = new URLSearchParams(location.search.toLowerCase());
    var paramsAttendee = (_b = queryParams.get("attendee")) !== null && _b !== void 0 ? _b : "";
    var paramsGroup = (_c = queryParams.get("group")) !== null && _c !== void 0 ? _c : "";
    var originalOrderId = (_e = (_d = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber))) !== null && _d !== void 0 ? _d : queryParams.get("originalorderid")) !== null && _e !== void 0 ? _e : "";
    var analytics = useWidgetAnalytics();
    var termKeys = getLocal(LOCAL_STORAGE_KEYS.AUTOREG_TERMS);
    var isAutoReg = path === Constants.Routes.autoreg && !(eventData === null || eventData === void 0 ? void 0 : eventData.isAssigned);
    var isSingleAttendeePicker = isSingleLocal || (isAutoReg && paramsAttendee !== "");
    var attendeeTypeData = isAutoReg ? typeData.filter(function (a) { return a.preRegEnabled; }) : typeData;
    var _6 = useGroupData((_f = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _f !== void 0 ? _f : 0), groupName = _6.groupName, groupId = _6.groupId;
    var showGroupedMatrix = ["brushfiretech", "legacyentertainmentgroup"].includes(((_g = eventData === null || eventData === void 0 ? void 0 : eventData.clientKey) !== null && _g !== void 0 ? _g : "").toLowerCase()) &&
        (eventData === null || eventData === void 0 ? void 0 : eventData.urlKey.toLowerCase()) === "tickets" &&
        [Constants.Routes.tickets, Constants.Routes.register].includes(path);
    var assessGroupsMode = function (allowButtons) {
        var _a;
        if (allowButtons === void 0) { allowButtons = true; }
        if (eventData && !groupsMode) {
            if (((_a = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.length) !== null && _a !== void 0 ? _a : 0) > 0) {
                if (eventData.hasGroupTypes || eventData.isGroupCentric || eventData.hasExistingGroups) {
                    if (groupId) {
                        setGroupsMode(GroupsMode.hide);
                    }
                    else if (!paramsAttendee || allowButtons) {
                        if (eventData.isGroupCentric) {
                            setGroupsMode(GroupsMode.buttons);
                        }
                        else {
                            setGroupsMode(GroupsMode.hide);
                        }
                    }
                    setHasGroups(true);
                }
                else {
                    setGroupsMode(GroupsMode.noGroups);
                }
            }
            else if (attendeeTypeData) {
                setGroupsMode(GroupsMode.noGroups);
            }
        }
    };
    useEffect(function () {
        assessGroupsMode(!paramsAttendee);
    }, [eventData, attendeeTypeData]);
    useEffect(function () {
        if (isAutoReg) {
            dispatch(setAutoRegMode(true));
        }
        else if ([Constants.Routes.tickets, Constants.Routes.register].includes(path)) {
            dispatch(setAutoRegMode(false));
        }
    }, [path]);
    useEffect(function () {
        var _a, _b;
        if (eventData &&
            cartStatus.isLoading === false &&
            path === Constants.Routes.addons &&
            cart &&
            ((_b = (_a = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0 &&
            !originalOrderId) {
            history.push(((eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? Constants.Routes.tickets : Constants.Routes.register)
                .replace(":clientKey", eventData.clientKey)
                .replace(":urlKey", eventData.urlKey)
                .replace(":eventNumber", eventData.eventNumber.toString()));
        }
    }, [path, eventData, cart, cartStatus]);
    useEffect(function () {
        if (paramsAttendee && isAutoReg) {
            //This is the old attendee Id
            getAttendee(paramsAttendee)
                .then(function (_a) {
                var _b;
                var data = _a.data;
                if (data.eventNumber !== (eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber)) {
                    setSourceAttendee(data);
                    setSourceAttendeeId(data.id);
                    if ((data.groupId || paramsGroup) && (eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber)) {
                        //There's no group for the destination event, so we need to find it
                        getGroupInEvent(paramsGroup !== "" ? paramsGroup : (_b = data.groupId) !== null && _b !== void 0 ? _b : "", eventData.eventNumber.toString())
                            .then(function (_a) {
                            var _b;
                            var data = _a.data;
                            setLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : ""), JSON.stringify({
                                groupId: paramsGroup,
                                name: data.name,
                            }));
                            setGroupsMode(GroupsMode.hide);
                            setRender(render + 1);
                        })
                            .catch(function (err) {
                            if (err.response.status === 404) {
                                setGroupsMode(GroupsMode.hide);
                            }
                            else {
                                handleErrors(err, dispatch);
                            }
                            assessGroupsMode();
                        });
                    }
                    else {
                        assessGroupsMode();
                    }
                }
            })
                .catch(function () {
                assessGroupsMode();
            });
        }
    }, [paramsAttendee, isAutoReg]);
    var accessibleAttendeeTypes = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return !a.isInaccessibleDueToAccessCode; });
    var groupingTexts = union((_h = accessibleAttendeeTypes
        .filter(function (a) {
        if (isAutoReg && (eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric) && !groupId) {
            return !a.isGroup;
        }
        else {
            return true;
        }
    })) === null || _h === void 0 ? void 0 : _h.map(function (a) { var _a; return (_a = a.groupingText) !== null && _a !== void 0 ? _a : constants === null || constants === void 0 ? void 0 : constants.ungroupedAttendeeTypeLabel; }));
    groupingTexts.push(groupingTexts.splice(groupingTexts.indexOf((_j = constants === null || constants === void 0 ? void 0 : constants.ungroupedAttendeeTypeLabel) !== null && _j !== void 0 ? _j : ""), 1)[0]);
    var amountOfTypesAvailable = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return a.isAvailable; }).length;
    var availabilityIsEqual = ((_k = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData[0]) === null || _k === void 0 ? void 0 : _k.available) === "Until Event" &&
        (attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.every(function (a, i, arr) { return a.available === arr[0].available; }));
    var hasInaccessibleType = !!(attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.isInaccessibleDueToAccessCode; }));
    var allHaveZeroPrice = accessibleAttendeeTypes === null || accessibleAttendeeTypes === void 0 ? void 0 : accessibleAttendeeTypes.every(function (a) {
        var _a;
        return ((section ? ((_a = section.priceBreakdown.find(function (p) { return p.typeId === a.id; })) === null || _a === void 0 ? void 0 : _a.amount) === 0 : a.amount === 0) &&
            a.variations.every(function (v) { return v.price === 0; }));
    });
    var anyHaveCustomAmount = !!(accessibleAttendeeTypes === null || accessibleAttendeeTypes === void 0 ? void 0 : accessibleAttendeeTypes.find(function (a) { return a.allowCustomAmount; }));
    var allHaveCustomAmount = accessibleAttendeeTypes === null || accessibleAttendeeTypes === void 0 ? void 0 : accessibleAttendeeTypes.every(function (a) { return a.allowCustomAmount; });
    var allAttendeeTypesHaveGroupsEnabled = accessibleAttendeeTypes === null || accessibleAttendeeTypes === void 0 ? void 0 : accessibleAttendeeTypes.every(function (a) { return a.isGroup; });
    var yourGroupGroupingText = (_l = accessibleAttendeeTypes === null || accessibleAttendeeTypes === void 0 ? void 0 : accessibleAttendeeTypes.find(function (a) { return a.yourGroup; })) === null || _l === void 0 ? void 0 : _l.groupingText;
    var attendeeTypesSchema = Yup.object().shape({
        attendeeTypes: Yup.array().of(Yup.object().shape({
            quantity: Yup.number().min(0),
            id: Yup.string().required(),
        })),
    });
    var continueToCart = function () {
        var _a;
        if (eventData) {
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber;
            var url = Constants.Routes.questions
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber.toString())
                .replace(Constants.Regex.guid, "")
                .replace(":attendeeId", "");
            if (path === Constants.Routes.calendar && !(window.parent && ((_a = window.parent) === null || _a === void 0 ? void 0 : _a.location) !== window.location)) {
                window.location.href = url;
            }
            else {
                history.push(url);
            }
        }
    };
    var continueToCheckout = function () {
        var _a;
        if (eventData) {
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber, addOns = eventData.addOns;
            var url = (addOns.filter(function (a) { return a.isAvailable; }).length > 0 && path !== Constants.Routes.addons
                ? Constants.Routes.addons
                : Constants.Routes.cart)
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber.toString());
            if (path === Constants.Routes.calendar && !(window.parent && ((_a = window.parent) === null || _a === void 0 ? void 0 : _a.location) !== window.location)) {
                window.location.href = url;
            }
            else {
                history.push(url);
            }
        }
    };
    var questionSubmitHistory = useTypedSelector(function (store) { return store.record; }).questionSubmitHistory;
    var shouldContinueToCheckout = function (cart, questions) {
        if (!cart || !questions) {
            return false;
        }
        return questions.every(function (q) {
            var _a;
            if (q.attendeeNumber === 0) {
                return (q.canContinue && (!cart.hasFields || (questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(cart.cartId))));
            }
            else {
                var attendeeId = (_a = cart.attendees.find(function (a) { return a.attendeeNumber === q.attendeeNumber; })) === null || _a === void 0 ? void 0 : _a.attendeeId;
                if (!attendeeId || q.fields.length === 0) {
                    return true;
                }
                return ((questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(attendeeId)) || (q.isPreRegistered && isAutoRegMode));
            }
        });
    };
    var continueToJoinGroup = function () {
        if (eventData) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("joinGroup", false);
            setGroupsMode(GroupsMode.joinGroup);
        }
    };
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        if (isAddonMatrix &&
            !isSingleAttendeePicker &&
            values.attendees.every(function (a) {
                return parseInt(a.quantity.toString()) === 0 &&
                    Object.values(a.variations).every(function (v) { return parseInt(v.quantity.toString()) === 0; });
            })) {
            continueToCheckout();
            formikHelpers.setSubmitting(false);
        }
        else if (handleSubmit) {
            if (selectedAttendeeType) {
                handleSubmit(values, formikHelpers, setGlobalError, selectedAttendeeType);
            }
        }
        else {
            dispatch(setFormIsSubmitting(true));
            formikHelpers.setSubmitting(true);
            if (!values.attendees.every(function (a) {
                return a.quantity.toString() === "0" &&
                    Object.values(a.variations).every(function (v) { return v.quantity.toString() === "0"; });
            }) ||
                selectedAttendeeType) {
                if (selectedAttendeeType && sourceAttendeeId) {
                    values.sourceAttendeeId = sourceAttendeeId;
                    values.attendees.forEach(function (a) {
                        if (a.typeId === selectedAttendeeType) {
                            a.quantity = 1;
                            a.isPreRegistered = true;
                        }
                        else {
                            a.quantity = 0;
                        }
                    });
                }
                else if (isAutoReg) {
                    values.attendees.forEach(function (a) {
                        a.isPreRegistered = true;
                    });
                }
                if (typeCode) {
                    values.typeCode = typeCode;
                }
                setShowAttendeeCountError(false);
                if (eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) {
                    if (values.attendees.some(function (a) { return a.quantity > 0 || Object.values(a.variations).some(function (v) { return v.quantity > 0; }); })) {
                        values.attendees.forEach(function (attendee) {
                            attendee.groupId = isAddonMatrix ? null : groupId || null;
                        });
                        if (values.attendees.some(function (a) {
                            var type = typeData.find(function (t) { return t.id === a.typeId; });
                            var isSelected = a.quantity > 0 && (type === null || type === void 0 ? void 0 : type.isAvailable);
                            var isGroupType = type === null || type === void 0 ? void 0 : type.isGroup;
                            var hasNoGroup = !a.groupId;
                            return isSelected && isGroupType && hasNoGroup;
                        })) {
                            setCartAddInput(values);
                            if (eventData) {
                                //Delay the redirect so the cartAddInput is ready before the form gets reset
                                setTimeout(function () {
                                    if (formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.joinGroup) {
                                        continueToJoinGroup();
                                    }
                                    else {
                                        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("joinGroup", true);
                                        if (eventData === null || eventData === void 0 ? void 0 : eventData.hasExistingGroups) {
                                            setGroupsMode(GroupsMode.joinGroup);
                                        }
                                        else {
                                            setGroupsMode(GroupsMode.createGroup);
                                        }
                                    }
                                }, 500);
                            }
                        }
                        else {
                            var cleanedValues = {
                                attendees: [],
                                eventNumber: values.eventNumber,
                                sourceAttendeeId: values.sourceAttendeeId,
                                typeCode: values.typeCode,
                            };
                            if (isAddonMatrix) {
                                var newAttendees_1 = [];
                                values.attendees.forEach(function (att) {
                                    var variationKeys = Object.keys(att.variations);
                                    if (variationKeys.length > 0) {
                                        variationKeys.forEach(function (varKey) {
                                            var _a;
                                            //Need to get variation externalId and description
                                            var variation = (_a = attendeeTypeData
                                                .find(function (a) { return a.id === att.typeId; })) === null || _a === void 0 ? void 0 : _a.variations.find(function (s) { return s.itemId === varKey; });
                                            if (variation) {
                                                newAttendees_1.push(__assign(__assign({}, att), { quantity: att.variations[varKey].quantity, externalId: variation.itemId, externalDescription: variation.name }));
                                            }
                                        });
                                    }
                                    else {
                                        newAttendees_1.push(att);
                                    }
                                });
                                cleanedValues.attendees = newAttendees_1;
                            }
                            else {
                                cleanedValues.attendees = values.attendees;
                            }
                            postAttendeeTypes(getCartId(eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber), cleanedValues)
                                .then(function (_a) {
                                var data = _a.data;
                                var cartData = data.cart;
                                if (cartData.communityLimitExceeded) {
                                    dispatch(updateCartStatus({
                                        isLoading: false,
                                        timesLoaded: cartStatus.timesLoaded + 1,
                                    }));
                                    dispatch(setInlineError({ registerHeaderError: cartData.error }));
                                    dispatch(setCartData(cartData));
                                    dispatch(setFormIsSubmitting(false));
                                    formikHelpers.setSubmitting(false);
                                    if (cartAddInput) {
                                        setCartAddInput(undefined);
                                        formikHelpers.resetForm({ values: initialValues });
                                    }
                                }
                                else {
                                    if (cartData.attendees.length) {
                                        getQuestions(cartData.cartId, cartData.eventNumber.toString()).then(function (_a) {
                                            var data = _a.data;
                                            dispatch(updateCartStatus({
                                                isLoading: false,
                                                timesLoaded: cartStatus.timesLoaded + 1,
                                            }));
                                            dispatch(setCartData(cartData));
                                            dispatch(setFormIsSubmitting(false));
                                            dispatch(setQuestionsData(data));
                                            formikHelpers.setSubmitting(false);
                                            if (cartAddInput) {
                                                setCartAddInput(undefined);
                                                formikHelpers.resetForm({ values: initialValues });
                                            }
                                            if (shouldContinueToCheckout(cartData, data)) {
                                                continueToCheckout();
                                            }
                                            else {
                                                if (formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.joinGroup) {
                                                    continueToJoinGroup();
                                                }
                                                else {
                                                    continueToCart();
                                                }
                                            }
                                        });
                                    }
                                }
                                analytics.addToCart(values, eventData);
                                if (selectedAttendeeType) {
                                    setSelectedAttendeeType(undefined);
                                }
                            })
                                .catch(function (err) {
                                handleErrors(err, dispatch, formikContext, setGlobalError);
                                formikHelpers.setSubmitting(false);
                                dispatch(setFormIsSubmitting(false));
                            });
                        }
                    }
                    else {
                        continueToCart();
                        formikHelpers.setSubmitting(false);
                        dispatch(setFormIsSubmitting(false));
                    }
                }
            }
            else {
                if (formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.joinGroup) {
                    continueToJoinGroup();
                }
                setShowAttendeeCountError(true);
                formikHelpers.setSubmitting(false);
                dispatch(setFormIsSubmitting(false));
            }
        }
    };
    var params = {};
    params = pick(qs.parse(window.location.search), ["type", "typeQty"]);
    var getDefaultValue = function (amount, type) {
        if (transferData && transferData[type.id]) {
            return transferData[type.id].quantity;
        }
        if (type.maxQuantity && amount > type.maxQuantity) {
            return type.maxQuantity;
        }
        else if (type.minQuantity && amount < type.minQuantity && amount !== 0) {
            return type.minQuantity;
        }
        else {
            return amount;
        }
    };
    var assessTransferValue = function (type) {
        if (transferData && transferData[type.id]) {
            return transferData[type.id].quantity;
        }
        return 0;
    };
    var initialValues = attendeeTypeData && eventData
        ? {
            attendees: attendeeTypeData.map(function (a) {
                var _a, _b, _c, _d, _e, _f;
                var quantity = !a.isInaccessibleDueToAccessCode
                    ? amountOfTypesAvailable === 1 && a.minQuantity === a.maxQuantity
                        ? a.minQuantity
                        : a.kind === "Virtual" || (a.maxQuantity === 1 && amountOfTypesAvailable === 1)
                            ? amountOfTypesAvailable === 1 && a.isAvailable
                                ? 1
                                : 0
                            : params.type && params.type === a.id && params.typeQty
                                ? getDefaultValue(parseInt(params.typeQty), a)
                                : transferData
                                    ? assessTransferValue(a)
                                    : 0
                    : 0;
                var variations = {};
                (_a = a.variations) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                    variations[variant.itemId] = {
                        quantity: quantity,
                    };
                });
                return {
                    id: a.id,
                    quantity: ((_c = (_b = a.variations) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0 ? 0 : quantity,
                    customAmount: a.allowCustomAmount ? (_d = a.allowedPayments[0]) !== null && _d !== void 0 ? _d : 0 : null,
                    amount: a.allowedPayments ? (_e = a.selectedAmount) !== null && _e !== void 0 ? _e : 0 : 0,
                    selectedAmount: a.selectedAmount,
                    //TODO add in these from params
                    typeId: a.id,
                    groupId: null,
                    isPreRegistered: false,
                    seatId: null,
                    sectionId: (_f = section === null || section === void 0 ? void 0 : section.id) !== null && _f !== void 0 ? _f : null,
                    variations: variations,
                    externalDescription: "",
                    externalId: "",
                };
            }),
            eventNumber: eventData.eventNumber,
            sourceAttendeeId: null,
            typeCode: typeCode !== null && typeCode !== void 0 ? typeCode : "",
        }
        : undefined;
    useEffect(function () {
        var _a;
        if (path === Constants.Routes.section && ((_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _a === void 0 ? void 0 : _a.matrixForm)) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.resetForm({ values: initialValues });
        }
    }, [section === null || section === void 0 ? void 0 : section.id]);
    var attendeeTypeLength = accessibleAttendeeTypes.length.toString();
    useEffect(function () {
        var _a, _b;
        if (((_b = (_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _a === void 0 ? void 0 : _a.bag) === null || _b === void 0 ? void 0 : _b.matrixForm) === true) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.resetForm({ values: cartAddInput !== null && cartAddInput !== void 0 ? cartAddInput : initialValues });
        }
    }, [attendeeTypeLength]);
    var validate = function (values) {
        var errors = {};
        /* 	if (values.attendees.every((a) => a.quantity.toString() === "0")) {
            errors.global = "At least one item is required to proceed.";
        } */
        if (customPriceErrors.length) {
            var hasErrors = values.attendees.filter(function (a) { return a.typeId && customPriceErrors.includes(a.typeId); });
            hasErrors === null || hasErrors === void 0 ? void 0 : hasErrors.forEach(function (a) {
                var _a, _b;
                console.log(a);
                if (a.typeId && ((_a = a.quantity) !== null && _a !== void 0 ? _a : 0) > 0) {
                    errors["attendees[".concat(values.attendees.indexOf(a), "].amount")] = "Price is below minimum requirement";
                }
                else if (((_b = a === null || a === void 0 ? void 0 : a.quantity) !== null && _b !== void 0 ? _b : 0) === 0) {
                    console.log(errors);
                    errors["attendees[".concat(values.attendees.indexOf(a), "].amount")] = undefined;
                    console.log(errors);
                }
            });
        }
        return errors;
    };
    var colCount = 3;
    if (allHaveZeroPrice && !anyHaveCustomAmount) {
        colCount--;
    }
    if (attendeeTypeData === undefined || initialValues === undefined || (eventIsLoading && !cartAddInput)) {
        return _jsx("div", {});
    }
    // if (amountOfTypesAvailable === 0) {
    // 	return (
    // 		<NoResults icon={eventData?.verbiage === "Tickets" ? "ticket" : "user-friends"} iconWeight="duotone">
    // 			<h4>
    // 				No {eventData?.verbiage === "Tickets" ? "ticket" : "registrant"} options currently available for
    // 				this {isAutoReg && paramsAttendee ? "attendee" : "event"}
    // 			</h4>
    // 		</NoResults>
    // 	);
    // }
    var renderAttendeeTypeRows = function (groupingText, formikContext) {
        if (eventData) {
            return attendeeTypeData.map(function (attendeeType, index) {
                var _a;
                return (_jsx(AttendeeTypeRow, { attendeeType: attendeeType, eventData: eventData, cart: cart, groupingTexts: groupingTexts, groupingText: groupingText, formikContext: formikContext, index: index, availabilityIsEqual: availabilityIsEqual, allHaveZeroPrice: allHaveZeroPrice, anyHaveCustomAmount: anyHaveCustomAmount, amountOfTypesAvailable: amountOfTypesAvailable, colCount: colCount, customPriceErrors: customPriceErrors, setCustomPriceErrors: setCustomPriceErrors, section: section, isSingleAttendeePicker: isSingleAttendeePicker, currentAttendeeTypeId: currentAttendeeTypeId, selectedAttendeeType: selectedAttendeeType, setSelectedAttendeeType: setSelectedAttendeeType, groupId: groupId, showGroupTypes: showGroupTypes, readonly: readonly, currentAttendeeTypePrice: currentAttendeeTypePrice, tightenUp: tightenUp, attendeeTypeData: attendeeTypeData, ungroupedAttendeeTypeLabel: (_a = constants === null || constants === void 0 ? void 0 : constants.ungroupedAttendeeTypeLabel) !== null && _a !== void 0 ? _a : "", hasUnpaidInvoice: hasUnpaidInvoice, setShowRemainingAlert: setShowRemainingAlert }, attendeeType.id));
            });
        }
        else {
            return null;
        }
    };
    var typeCol = function () {
        if (colCount === 4) {
            return 5;
        }
        else if (colCount === 3) {
            return 7;
        }
        else {
            return 10;
        }
    };
    var onContinue = function (values, formikHelpers) {
        formikHelpers.setSubmitting(false);
        setAcceptedTerms(true);
        if (eventData) {
            setLocal(LOCAL_STORAGE_KEYS.AUTOREG_TERMS, termKeys ? "".concat(termKeys, "|").concat(eventData.eventNumber.toString()) : eventData.eventNumber.toString());
        }
    };
    if (isAutoReg &&
        path === Constants.Routes.autoreg &&
        !!groupsMode &&
        [GroupsMode.hide, GroupsMode.noGroups].includes(groupsMode) &&
        (eventData === null || eventData === void 0 ? void 0 : eventData.autoRegTerms) &&
        !acceptedTerms &&
        !(termKeys === null || termKeys === void 0 ? void 0 : termKeys.split("|").includes(eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber.toString()))) {
        return (_jsxs("div", __assign({ className: "auto-group" }, { children: [_jsxs(Alert, __assign({ purpose: "info" }, { children: [_jsx("h4", { children: "TERMS AND CONDITIONS" }), _jsx("p", __assign({ className: "m-bottom-0" }, { children: "You must agree to the following before you may continue." }))] })), _jsx("div", { className: "wysiwyg-plain-text wysiwyg-text", dangerouslySetInnerHTML: { __html: eventData === null || eventData === void 0 ? void 0 : eventData.autoRegTerms } }), _jsx(Form, __assign({ initialValues: {}, onSubmit: onContinue, useUnsavedPrompt: false, formikBagProps: {
                        submitButtonLabel: "I Agree",
                    } }, { children: function (_a) {
                        var formikContext = _a.formikContext;
                        return (_jsx(WidgetFieldset, { children: _jsx(FormikContextListener, { currentPath: path, path: "".concat(Constants.Routes.autoreg), formikContext: formikContext, active: true }) }));
                    } }))] })));
    }
    var allMatrixItemsAreZero = (_o = (_m = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _m === void 0 ? void 0 : _m.attendees) === null || _o === void 0 ? void 0 : _o.every(function (a) {
        return parseInt(a.quantity.toString()) === 0 &&
            Object.values(a.variations).every(function (v) { return parseInt(v.quantity.toString()) === 0; });
    });
    var submitButtonLabel = isAddonMatrix && !isSingleAttendeePicker && allMatrixItemsAreZero && !originalOrderId ? "Skip For Now" : null;
    return (_jsxs(_Fragment, { children: [showRemainingAlert && (section === null || section === void 0 ? void 0 : section.spotsRemaining) && (_jsx(Alert, __assign({ purpose: "danger" }, { children: _jsx("p", __assign({ className: "m-bottom-0" }, { children: (section === null || section === void 0 ? void 0 : section.spotsRemaining) > 1
                        ? "There are only ".concat(section === null || section === void 0 ? void 0 : section.spotsRemaining, " spots remaining for this section.")
                        : "There is only one spot remaining for this section." })) }))), (eventData === null || eventData === void 0 ? void 0 : eventData.hasActiveTypeCodes) && hasInaccessibleType && (!readonly || isGroupButtonsMatrix) && (_jsx(AccessCodeInput, { eventData: eventData, codeType: "typeCode" })), groupName && !path.includes("/my") && path !== Constants.Routes.autogroup && !isAddonMatrix && !readonly && (_jsxs("div", __assign({ className: "your-group-header" }, { children: [_jsxs("p", { children: ["Registering as a part of: ", groupName] }), allAttendeeTypesHaveGroupsEnabled ? (_jsx(Button, __assign({ purpose: "plain", onClick: function () {
                            removeLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber));
                            queryParams.delete("joinCode");
                            queryParams.delete("group");
                            domHistory.replace({
                                search: queryParams.toString(),
                            });
                            setRender(render + 1);
                            if (eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric) {
                                setGroupsMode(GroupsMode.buttons);
                            }
                        } }, { children: "Change group" }))) : (_jsx(Button, __assign({ purpose: "plain", onClick: function () {
                            removeLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber));
                            queryParams.delete("joinCode");
                            queryParams.delete("group");
                            domHistory.replace({
                                search: queryParams.toString(),
                            });
                            setRender(render + 1);
                        } }, { children: "Register as an individual instead" })))] }))), (eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric) &&
                !groupName &&
                hasGroups &&
                !path.includes("/my") &&
                path !== Constants.Routes.autogroup &&
                !readonly && (_jsxs("div", __assign({ className: "your-group-header gray" }, { children: [_jsx("p", { children: "Registering as an individual" }), !allAttendeeTypesHaveGroupsEnabled && (_jsx(Button, __assign({ purpose: "plain", onClick: function () {
                            setGroupsMode(GroupsMode.buttons);
                        } }, { children: "Register as a group instead" })))] }))), !showGroupedMatrix ? (_jsx(Form, __assign({ initialValues: initialValues, validationSchema: attendeeTypesSchema, onSubmit: onSubmit, validate: validate, formikBagProps: { matrixForm: true, submitButtonLabel: submitButtonLabel }, useUnsavedPrompt: false }, { children: function (_a) {
                    var _b;
                    var formikContext = _a.formikContext;
                    var hasNoQuantity = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values.attendees.every(function (a) {
                        return parseInt(a.quantity.toString()) === 0 &&
                            Object.values(a.variations).every(function (v) { return parseInt(v.quantity.toString()) === 0; });
                    });
                    var disableCartButton = ((!(isAddonMatrix && !originalOrderId && hasNoQuantity) || isSingleAttendeePicker) &&
                        !((amountOfTypesAvailable === 1 && attendeeTypeData[0].maxQuantity === 1) ||
                            (amountOfTypesAvailable === 1 &&
                                attendeeTypeData[0].minQuantity === attendeeTypeData[0].maxQuantity)) &&
                        hasNoQuantity &&
                        !selectedAttendeeType) ||
                        isDisabled;
                    if ((_b = formikContext.status) === null || _b === void 0 ? void 0 : _b.bag) {
                        formikContext.status.bag.disableCartButton = disableCartButton;
                    }
                    else {
                        formikContext.status = { bag: disableCartButton };
                    }
                    return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: path, path: [
                                    Constants.Routes.tickets,
                                    Constants.Routes.register,
                                    Constants.Routes.section,
                                    Constants.Routes.autoreg,
                                    Constants.Routes.autogroup,
                                    Constants.Routes.myAttendeeType,
                                    Constants.Routes.calendar,
                                    Constants.Routes.addons,
                                ], formikContext: formikContext, active: ((groupsMode === GroupsMode.hide && path !== Constants.Routes.calendar) ||
                                    (groupsMode === GroupsMode.noGroups &&
                                        path !== Constants.Routes.calendar) ||
                                    isSingleAttendeePicker ||
                                    (!(eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric) &&
                                        groupsMode &&
                                        ![GroupsMode.joinGroup, GroupsMode.createGroup].includes(groupsMode)) ||
                                    (path === Constants.Routes.calendar &&
                                        (groupsMode === GroupsMode.hide ||
                                            groupsMode === GroupsMode.noGroups))) &&
                                    activePaths.includes(path), timesLoaded: cartStatus.timesLoaded, initialValues: cartAddInput !== null && cartAddInput !== void 0 ? cartAddInput : initialValues }), setAttendeeTypesFormData && (_jsx(FormikValuesListener, { values: attendeeTypesFormData, setValues: setAttendeeTypesFormData, setSubmit: function () { return null; } })), _jsx(GroupMiddlewareListener, { active: [
                                    Constants.Routes.tickets,
                                    Constants.Routes.register,
                                    Constants.Routes.section,
                                    Constants.Routes.autoreg,
                                    Constants.Routes.autogroup,
                                ].includes(path) ||
                                    [GroupsMode.createGroup, GroupsMode.joinGroup].includes(groupsMode !== null && groupsMode !== void 0 ? groupsMode : GroupsMode.hide) ||
                                    (Constants.Routes.calendar === path && groupsMode === GroupsMode.hide), groupId: groupId, submitCartAddInput: onSubmit, cartAddInput: cartAddInput }), isAddonMatrix && (eventData === null || eventData === void 0 ? void 0 : eventData.addonTitle) && (_jsx("h4", __assign({ className: "h4 semi-bold mb-0" }, { children: eventData.addonTitle }))), amountOfTypesAvailable > 0 && !isAddonMatrix && (_jsxs(Row, __assign({ className: "p-0 m-0 attendee-type-header-row ".concat(groupingTexts.filter(function (t) { return t !== (constants === null || constants === void 0 ? void 0 : constants.ungroupedAttendeeTypeLabel); })
                                    .length > 0
                                    ? "has-grouping-text-headers"
                                    : "") }, { children: [_jsx(Col, __assign({ md: typeCol() -
                                            (isSingleAttendeePicker ? 1 : 0) +
                                            (readonly ? (isSingleAttendeePicker ? 3 : 2) : 0) }, { children: _jsx("h5", __assign({ className: "tt-uppercase attendee-type-header m-0" }, { children: "".concat((eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "Ticket" : "Registrant", " type") })) })), (!allHaveZeroPrice || anyHaveCustomAmount) && (_jsx(Col, __assign({ md: 3, className: "d-flex justify-content-center " }, { children: _jsx("h5", __assign({ className: "tt-uppercase attendee-type-header m-0" }, { children: allHaveCustomAmount && !readonly ? "Amount" : "Price" })) }))), !readonly && (_jsx(Col, __assign({ md: isSingleAttendeePicker ? 3 : 2, className: isSingleAttendeePicker ? "ta-center" : "ta-right" }, { children: _jsx("div", __assign({ className: "quantity-text" }, { children: _jsx("h5", __assign({ className: "tt-uppercase attendee-type-header  m-0" }, { children: isSingleAttendeePicker ? "Select" : "Quantity" })) })) })))] }))), groupingTexts.map(function (groupingText) {
                                var groupAttendeeTypes = attendeeTypeData.filter(function (a) {
                                    return (a.groupingText === groupingText ||
                                        (groupingText === (constants === null || constants === void 0 ? void 0 : constants.ungroupedAttendeeTypeLabel) &&
                                            !a.groupingText)) &&
                                        !a.isInaccessibleDueToAccessCode;
                                });
                                var allTypesAreHidden = groupAttendeeTypes.length === 0;
                                if (!allTypesAreHidden)
                                    return (_jsxs("div", __assign({ className: "matrix-group ".concat(groupingTexts.length > 1 ? "has-grouping-text-headers" : "") }, { children: [groupingTexts.length > 1 && (_jsx("h6", __assign({ className: "grouping-text-header m-0 ".concat(yourGroupGroupingText === groupingText
                                                    ? "your-group"
                                                    : !!yourGroupGroupingText
                                                        ? "not-your-group"
                                                        : "") }, { children: "".concat(groupingText !== null && groupingText !== void 0 ? groupingText : constants === null || constants === void 0 ? void 0 : constants.ungroupedAttendeeTypeLabel, " ").concat(yourGroupGroupingText === groupingText
                                                    ? "- Your Group"
                                                    : !!yourGroupGroupingText
                                                        ? "- Not Your Group"
                                                        : "", " ") }), groupingText)), _jsx("div", __assign({ className: "".concat(groupingTexts.length > 1 &&
                                                    "attendee-type-group-container") }, { children: _jsx(WidgetFieldset, __assign({ isDisabled: isDisabled }, { children: renderAttendeeTypeRows(groupingText, formikContext) })) }))] }), groupingText));
                            }), amountOfTypesAvailable === 0 && (_jsx(NoResults, __assign({ icon: (eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "ticket" : "user-friends", iconWeight: "duotone" }, { children: _jsxs("h4", { children: ["No ", (eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "ticket" : "registrant", " options currently available for this event"] }) }))), formikContext.errors.global && formikContext.submitCount > 0 && (_jsx("div", __assign({ className: "error" }, { children: _jsx(Error, __assign({ ariaLive: "polite" }, { children: formikContext.errors.global })) })))] }));
                } }))) : (_jsx(_Fragment, { children: _jsx(GroupedMatrix, { currency: (_p = eventData.currency) !== null && _p !== void 0 ? _p : "USD", attendeeTypeData: attendeeTypeData, submitAttendees: onSubmit, eventNumber: eventData.eventNumber, typeCode: typeCode, path: path }) }))] }));
};
export default AttendeeTypes;
